import { z } from 'zod';

export const showFormSchema = z.object({
  name: z
    .string()
    .min(1, 'Show name is required'),

  hostName: z
    .string()
    .min(1, 'Host name is required'),

  description: z
    .string()
    .min(1, 'Description is required'),

  isActive: z.boolean(),

  categories: z
    .array(z.string())
    .min(1, 'At least one category is required'),

  thumbnail: z
    .union([
      z.string().optional(),
      z.instanceof(File)
        .refine(file => file.size <= 5 * 1024 * 1024, 'File size must be < 5MB')
        .refine(
          file =>
            ['image/jpeg', 'image/png', 'image/webp', 'image/jpg'].includes(file.type),
          'Only JPG, PNG, WEBP allowed'
        )
    ])
    .optional()
});

export type ShowFormValues = z.infer<typeof showFormSchema>;
